import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { useTranslation } from "react-i18next";
import React from "react";

export default function TableHeader({
  classes,
  order,
  orderBy,
  onRequestSort,
  headCells,
}) {
  const { i18n } = useTranslation();

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={i18n.dir() === "rtl" ? "left" : "right"}
            // align="left"
            sortDirection={orderBy === headCell.id ? order : false}
            className={headCell.directionCenter ? classes.tableHeader : ""}
          >
            {headCell.isNeedSort ? (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
                className={i18n.dir() === "rtl" ? "" : classes.iconDirectionLtr}
              >
                {headCell.directionCenter ? (
                  <span
                    style={{
                      padding: "12px",
                    }}
                  ></span>
                ) : (
                  <></>
                )}
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
